import React from 'react';
import { MessageBanner, MessageBannerType } from '@amzn/atoz-web/MessageBanner';
import { Text } from '@amzn/atoz-web/Text';
import { useTranslation } from 'react-i18next';
export var SwapPageBanner = function (_a) {
    var swapFromDate = _a.swapFromDate;
    var t = useTranslation().t;
    var dateString = swapFromDate.toLocaleString({
        weekday: 'short',
        day: 'numeric',
        month: 'short'
    });
    return (React.createElement(MessageBanner, { dataTestId: "SwapPageBanner", type: MessageBannerType.Informational },
        React.createElement(Text, null, t('shift_management_features_SwapPageBanner_bannerText', {
            swapFromDate: dateString
        }))));
};
